export enum AGENTS_DEFAULT_FIELDS {
  SYNC_DESIGNATION = 'Sync Designation',
  SYNC_CODE = 'Sync Code',
  SYNC_CAREER_LEVEL = 'Sync Career Level',
  SYNC_POSITION = 'Sync Position',
  SYNC_NATURE_TYPE = 'Sync Nature Type',
  SYNC_AGENT_CLASS = 'Sync Agent Class',
  SYNC_RANK = 'Sync Rank',
  SYNC_CHANNEL = 'Sync Channel',
  SYNC_EMPLOYMENT_TYPE = 'Sync Employment Type',

  SUB_CAREER_LEVEL = 'Sync Sub Career Level',
  SUB_POSITIONS_CAREER_LEVEL = 'Sync Sub Positions Career Level',
  SUB_POSITIONS_POSITION = 'Sync Sub Positions Position',
  SUB_CHANNELS_CHANNEL = 'Sync Sub Channels Channel',
  SUB_CHANNELS_CODE = 'Sync Sub Channels Code',
  SUB_EMPLOYMENT_TYPE = 'Sync Sub Employment Type',

  SUB_DESIGNATION_MAPPING_DESIGNATION = 'Designation Mapping Designation',
  SUB_DESIGNATION_MAPPING_ROLE = 'Designation Mapping Role',
  SUB_DESIGNATION_MAPPING_PERFORMANCE_ACTIVE = 'Designation Mapping Performance Active',
}

// {
//         "COMPANYCODE": "00003",
//         "CAREERLEVEL": "Agent",
//         "POSITION": "Agent",
//         "DESIGNATION": "Trainee Business Associate (TBA)",
//         "NATURETYPE": "A",
//         "AGENTCLASS": "BTA",
//         "PRIMARYLEVEL": "1",
//         "CATEGORY": "N",
//         "SUBLEVEL": 1,
//         "CREATEDT": "2023-06-14T13:05:18.000Z",
//         "CREATEBY": "AVOIBPS_REP"
//     },
